export const PACKAGE_NAME = 'jiraIssueTableGroupByDropdown';
export const TEAM_NAME = 'jira-yurree';

export const GROUP_BY_DROPDOWN_EXPERIENCE = 'loadGroupByOptions';
export const ANALYTICS_SOURCE = 'jira-native-issue-table' as const;

export const GROUP_BY_DROPDOWN_CHANGED_EXPERIENCE = 'changeGroupByField';

export const GROUP_BY_DROPDOWN_LOAD_MORE_TRIGGER_EXPERIENCE = 'groupByDropdownLoadMoreTrigger';

export const GROUP_BY_DROPDOWN_SEARCH_EXPERIENCE = 'groupByDropdownSearch';
